/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Model_Breakdown_DescriptionInputs */



/**
* | output |
* | --- |
* | "Detailed token and cost breakdown per model" |
*
* @param {Dashboard_Model_Breakdown_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_model_breakdown_description = /** @type {((inputs?: Dashboard_Model_Breakdown_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Model_Breakdown_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Detaillierte Token- und Kostenaufschlüsselung pro Modell")
	return /** @type {LocalizedString} */ ("Detailed token and cost breakdown per model")
});